import * as React from "react";
import { style } from "typestyle";

const AlignCenter = ({ children }: any) => (
  <div
    className={style({
      width: "100%",
      height: "100%",
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    })}
  >
    {children}
  </div>
);

export default AlignCenter;
